import React from "react";
import VideoSection from "./../components/VideoSection";

function LiturgicalReflectionsPage(props) {
  return (
    <VideoSection
      bgColor="light"
      size="medium"
      bgImage=""
      bgImageOpacity={1}
      title="Holy Bible in the Holy Liturgy"
      subtitle=""
      embedUrl="https://www.youtube.com/embed/BP_V4rZcdAQ"
    />
  );
}

export default LiturgicalReflectionsPage;
